import { EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Radio, Input, Table, Spin, Space, Switch } from "antd";
import { useState } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import useDebounce from "../../../hooks/useDebounce";
import WelcomeTopbar from "../../../components/common/header/WelcomeTopbar";
import {
  getDevicesRequest,
  updateDeviceRequest,
} from "../../../api/requests/device";
import { DATE_FORMAT } from "../../../utils/date";

const { Search } = Input;

function DevicesPage() {
  const navigate = useNavigate();
  const [value, setValue] = useState(1);
  const [name, setName] = useState();
  const debouncedName = useDebounce(name, 500);

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const params = {
    name: debouncedName,
  };

  const { data: deviceListRes, isLoading: isLoadingDeviceList } = useQuery({
    queryKey: ["devices", params],
    queryFn: async () => {
      const res = await getDevicesRequest({
        params,
      });
      return res.data?.data;
    },
  });

  const {
    mutateAsync: updateDevice,
    isPending: updatingDevice,
    variables,
  } = useMutation({
    mutationFn: async ({ id, data }) => {
      const res = await updateDeviceRequest({
        id,
        data,
      });
      return res.data;
    },
    mutationKey: ["device/update"],
    onSuccess: (res) => {
      const successMessage = res?.message;
      if (successMessage) {
        message.success(successMessage);
      }
    },
    onError: (error) => {
      mutationOnErrorHandler({ error, message });
    },
  });

  function navigateToUpdate(id) {
    navigate(`/setup/devices/update/${id}`);
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Business Details",
      dataIndex: "businessDetails",
      key: "businessDetails",
      render: (text) => text ?? "-",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render: (text) => text?.join(", ") ?? "-",
    },
    {
      title: "Address",
      key: "address",
      render: ({ address = {} }) => {
        const { street, city } = address;
        return `${street} ${city}`;
      },
    },
    {
      title: "Active",
      key: "active",
      render: ({ active, _id }) => {
        return (
          <Switch
            loading={updatingDevice && variables?.id === _id}
            defaultChecked={active}
            onChange={(active) => {
              updateDevice({
                id: _id,
                data: { active: active },
              });
            }}
          />
        );
      },
    },
    {
      title: "Updated At",
      key: "updatedAt",
      render: ({ updatedAt }) => {
        return dayjs(updatedAt).format(DATE_FORMAT);
      },
    },
    {
      title: "Action",
      render: (details) => {
        return (
          <Space>
            <Button
              onClick={() => {
                navigateToUpdate(details._id);
              }}
            >
              <EditOutlined />
            </Button>
          </Space>
        );
      },
      key: "action",
    },
  ];

  function renderTable() {
    if (isLoadingDeviceList) {
      return (
        <Spin tip="Loading" size="large">
          <div className="p-14" />
        </Spin>
      );
    }

    return (
      <Table
        dataSource={deviceListRes || []}
        columns={columns}
        rowKey={"_id"}
        // pagination={{
        //   total: receiveSizeBeamListRes?.count || 0,
        //   showSizeChanger: true,
        //   onShowSizeChange: onShowSizeChange,
        //   onChange: onPageChange,
        // }}
        pagination={false}
        style={{
          overflow: "auto",
        }}
      />
    );
  }

  return (
    <div className="flex flex-col gap-6">
      <WelcomeTopbar />
      <div className="flex flex-col gap-6 px-6 pb-6">
        <div className="flex flex-col gap-6 rounded-xl border-2 pb-6">
          <div className="flex min-h-14 justify-between rounded-t-xl bg-[#D1DFFF] px-6 py-3">
            <div className="flex gap-2 text-2xl">
              {/* <PlusCircleOutlined /> */}
              <div>Devices</div>
            </div>
            <div>
              <Button
                onClick={() => {
                  navigate("/setup/devices/add");
                }}
              >
                Create Device
              </Button>
            </div>
          </div>
          <div className="flex gap-6 px-6">
            <Button className="flex-grow">Employees</Button>
            <Button className="flex-grow">Carriers</Button>
          </div>
          <div className="flex items-center justify-between gap-6 px-6">
            <Radio.Group onChange={onChange} value={value}>
              <Radio value={"Farmers"}>Farmers</Radio>
              <Radio value={"Processors"}>Processors</Radio>
            </Radio.Group>
            <div>
              <Search
                placeholder="Search"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </div>
          </div>

          {renderTable()}
        </div>
      </div>
    </div>
  );
}

export default DevicesPage;
